import { Text } from '@/components'
import { getConfig } from '../../config'
import { useTranslation } from 'react-i18next'

export function LegalNotice() {
  const { t } = useTranslation()
  const { termsOfServiceUrl, companyUrl, privacyPolicyUrl } = getConfig()

  return (
    <Text variant='extra-small' color='text-gray'>
      {t('legalNotice.termsIntro')}{' '}
      <a
        href={termsOfServiceUrl ?? '#'}
        target='_blank'
        className='text-cencert-blue underline hover:no-underline'
      >
        {t('legalNotice.termsLink')}
      </a>
      . {t('legalNotice.dataController')}{' '}
      <a
        href={companyUrl ?? '#'}
        target='_blank'
        className='text-cencert-blue underline hover:no-underline'
      >
        {t('legalNotice.companyName')}
      </a>{' '}
      {t('legalNotice.privacyInfo')}{' '}
      <a
        href={privacyPolicyUrl ?? '#'}
        target='_blank'
        className='text-cencert-blue underline hover:no-underline'
      >
        {t('legalNotice.privacyLink')}
      </a>
      .
    </Text>
  )
}
